import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const InboxContext = createContext({ count: 0, refresh: () => {}, setCount: () => {} });
export const useInbox = () => useContext(InboxContext);

export function InboxProvider({ children }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (!user) return;
    api.get("/inbox?tab=active").then((r) => setCount(r.data.active_count)).catch(() => {});
  }, [user]);

  useEffect(() => {
    if (!user) { setCount(0); return; }
    refresh();
    const t = setInterval(refresh, 12000);
    const onFocus = () => { if (document.visibilityState !== "hidden") refresh(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      clearInterval(t);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [user, refresh]);

  return (
    <InboxContext.Provider value={{ count, refresh, setCount }}>
      {children}
    </InboxContext.Provider>
  );
}
